import React, { useState } from "react";
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { TbCurrencyDollar } from "react-icons/tb";

const bedrooms = [];
for (let i = 1; i <= 20; i++) {
  bedrooms.push({ value: i });
}

const bathrooms = [];
for (let i = 0.0; i <= 20; i = i + 0.5) {
  bathrooms.push({ value: i });
}

function RentalInformation({ propertyType }) {
  const [checked, setChecked] = useState(false);
  const [customInspection, setCustomInspection] = useState(false);
  return (
    <>
      {propertyType === "Single Family" ? (
        <>
          <Form.Item label="Bedrooms" name="bedrooms">
            <Select options={bedrooms} />
          </Form.Item>
          <Form.Item label="BathRooms" name="bathrooms">
            <Select options={bathrooms} />
          </Form.Item>
          <Form.Item label="Square Feet" name="squareFeet">
            <Input />
          </Form.Item>
          <Form.Item label="Market Rent" name="marketRent">
            <InputNumber
              addonBefore={<TbCurrencyDollar size={16} />}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            label="Use Market Rent on Ads?"
            name="marketRentOnAds"
            valuePropName="checked"
          >
            <Checkbox
              checked={checked}
              onChange={() => setChecked(!checked)}
            ></Checkbox>
          </Form.Item>
          {!checked && (
            <Form.Item label="Advertised Rent" name="advertisedRent">
              <InputNumber
                addonBefore={<TbCurrencyDollar size={16} />}
                style={{ width: "100%" }}
              />
            </Form.Item>
          )}
          <Form.Item label="Application Fee" name="applicationFee">
            <InputNumber
              addonBefore={<TbCurrencyDollar size={16} />}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item label="Security Deposit" name="securityDeposit">
            <InputNumber
              addonBefore={<TbCurrencyDollar size={16} />}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </>
      ) : null}
      <Form.Item label="NSF Fee" name="NSFFee">
        <InputNumber
          addonBefore={<TbCurrencyDollar size={16} />}
          style={{ width: "100%" }}
        />
      </Form.Item>
      {propertyType === "Single Family" ? (
        <>
          <Form.Item
            label="Use Custom Inspection Date"
            name="useCustomInspectionDate"
            valuePropName="checked"
          >
            <Checkbox
              checked={customInspection}
              onChange={() => setCustomInspection(!customInspection)}
            ></Checkbox>
          </Form.Item>
          <Form.Item label="Last Inspection On" name="lastInspectionOn">
            {customInspection ? <DatePicker /> : <p>--</p>}
          </Form.Item>
          <Form.Item label="Rent Status" name="RentStatus">
            <Select
              options={[
                { value: "Rent Corntrolled" },
                { value: "Rent Stabilized" },
                { value: "Decontrolled" },
              ]}
            />
          </Form.Item>
          <Form.Item label="Legal Rent" name="legalRent">
            <InputNumber
              addonBefore={<TbCurrencyDollar size={16} />}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item label="Preferential Rent" name="preferentialRent">
            <InputNumber
              addonBefore={<TbCurrencyDollar size={16} />}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item label="Utilities Included In Lease" name="leaseUtilities">
            <Select
              mode="tags"
              tokenSeparators={[]}
              options={[
                {
                  value:
                    "Water and trash included with a $50 dollar charge added to rent.",
                },
                { value: "water and internet" },
                { value: "water and trash" },
                { value: "all bills paid" },
              ]}
            />
          </Form.Item>
          {/* <Form.Item label=" ">
            <Button type="link">Manage Tags</Button>
          </Form.Item> */}
          <Form.Item
            label="Appliances Included In Lease"
            name="leaseAppliances"
          >
            <Select
              mode="tags"
              tokenSeparators={[]}
              options={[
                { value: "Fridge and Stove are only appliances furnished." },
                { value: "window ac" },
                { value: "Washer and Dryer" },
                { value: "only fridge belongs to tenant" },
              ]}
            />
          </Form.Item>
          {/* <Form.Item label=" ">
            <Button type="link">Manage Tags</Button>
          </Form.Item> */}
          <Form.Item
            label="Additional Lease Information"
            name="additionalLeaseInformation"
          >
            <TextArea rows={6} />
          </Form.Item>
        </>
      ) : null}
    </>
  );
}

export default RentalInformation;
